import React from 'react';

class AsyncRoute extends React.Component {
  constructor(props) {
    super(props);
    this.state = { status: 'loading', Page: null };
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    Promise.resolve(this.props.component).then(
      (module) => {
        if (this.mounted) this.setState({ status: 'ready', Page: module.default });
      },
      () => {
        if (this.mounted) this.setState({ status: 'error' });
      },
    );
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { status, Page } = this.state;
    if (status === 'ready') return <Page {...this.props} />;
    if (status === 'error') {
      return (
        <div role="alert" style={{ padding: 24 }}>
          <p>页面加载失败，请检查网络或开发服务后重试。</p>
          <button type="button" onClick={() => window.location.reload()}>重新加载页面</button>
        </div>
      );
    }
    return <div style={{ padding: 24 }}>页面加载中…</div>;
  }
}

export default AsyncRoute;
